import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { EmployeeGender, JoinEmployeeFlowStep } from './joinEmployeeFlow.utils';

interface PersonalFormData {
  gender: EmployeeGender;
  firstName: string;
  lastName: string;
  middleName: string;
  dateOfBirth: Date;
  email: string;
}

interface SpouseData {
  firstName: string;
  lastName: string;
  middleName: string;
  dateOfBirth: Date;
}

interface JoinEmployeeFlowState {
  steps: JoinEmployeeFlowStep[];
  activeStepIndex: number;
  personalData: Nullable<PersonalFormData>;
  spouseData: Nullable<SpouseData>;
}

const initialState: JoinEmployeeFlowState = {
  steps: [
    JoinEmployeeFlowStep.PersonalData,
    JoinEmployeeFlowStep.FamilyStatus,
    JoinEmployeeFlowStep.Children,
    JoinEmployeeFlowStep.PassportData,
    JoinEmployeeFlowStep.RegistrationAddress,
    JoinEmployeeFlowStep.ResidenceAddress,
    JoinEmployeeFlowStep.Education,
    JoinEmployeeFlowStep.MilitaryRegistration,
    JoinEmployeeFlowStep.SocialStatuses,
  ],
  activeStepIndex: 5,
  personalData: null,
  spouseData: null,
};

export const joinEmployeeFlowSlice = createSlice({
  name: 'joinEmployeeFlow',
  initialState,
  reducers: {
    nextStep: (state) => {
      state.activeStepIndex += 1;
    },
    submitPersonalDataForm: (
      state,
      action: PayloadAction<PersonalFormData>,
    ) => {
      state.personalData = action.payload;
      state.activeStepIndex += 1;
    },
    submitMarriedDataForm: (state, action: PayloadAction<SpouseData>) => {
      state.spouseData = action.payload;
      state.activeStepIndex += 1;
    },
    prevStep: (state) => {
      state.activeStepIndex -= 1;
    },
  },
  selectors: {
    selectActiveStepIndex: (state) => state.activeStepIndex,
    selectActiveStep: (state) => state.steps[state.activeStepIndex],
    selectSteps: (state) => state.steps,
    selectPersonalData: (state) => state.personalData,
    selectGender: (state) => state.personalData?.gender,
    selectFirstName: (state) => state.personalData?.firstName,
    selectSpouseFirstName: (state) => state.spouseData?.firstName,
  },
});
